import useProfile from 'hooks/useProfile';
import React from 'react'
import { useDispatch } from 'react-redux';
import { updateProfileDataRequest } from 'services/userFlagsService';
import { editUsersFlag } from 'store/user';

const ProfileShowOnboardingCards = ({playSound}) => {
  const dispatch = useDispatch();
  const {flags} = useProfile();
  const {onboarding} = flags;

  const setIsOnboardingCardsShown = async () => {
    playSound('main');
    dispatch(editUsersFlag({field: 'onboarding', value: !onboarding}))
    try {
      await updateProfileDataRequest({flags: {onboarding: !onboarding}});
    } catch (e) {
      console.log('error of changing show onboarding cards in profile:', e);
    }
  };

  return (
    <li className="profile-content__settings-item">
      <b>Show onboarding cards:</b>
      <input
        type="checkbox"
        id="onboarding-cards"
        checked={onboarding}
        onChange={setIsOnboardingCardsShown}
      />
      <label htmlFor="onboarding-cards"></label>
    </li>
  )
}

export default ProfileShowOnboardingCards;
